var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrmShapes1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 677,
    height: 91,
    viewBox: "0 0 677 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 119.837,
    y: 116.921,
    width: 164.686,
    height: 219.057,
    transform: "rotate(-42.952 119.837 116.921)",
    fill: "#F5C000",
    stroke: "#3913D2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 119.13,
    y: 120.703,
    width: 165.686,
    height: 220.057,
    transform: "rotate(-42.952 119.13 120.703)",
    fill: "#F5C000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 173.16,
    y: 133.585,
    width: 164.686,
    height: 219.057,
    transform: "rotate(-42.952 173.16 133.585)",
    fill: "#38CB89",
    stroke: "#3913D2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 172.453,
    y: 137.367,
    width: 165.686,
    height: 220.057,
    transform: "rotate(-42.952 172.453 137.367)",
    fill: "#38CB89"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 138.403,
    y: 123.585,
    width: 164.686,
    height: 219.057,
    transform: "rotate(-42.952 138.403 123.585)",
    stroke: "#3913D2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 137.696,
    y: 127.367,
    width: 165.686,
    height: 220.057,
    transform: "rotate(-42.952 137.696 127.367)",
    fill: "#4E5D78"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 191.726,
    y: 140.249,
    width: 164.686,
    height: 219.057,
    transform: "rotate(-42.952 191.726 140.249)",
    stroke: "#3913D2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 191.02,
    y: 144.031,
    width: 165.686,
    height: 220.057,
    transform: "rotate(-42.952 191.02 144.031)",
    fill: "#4E5D78"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 352.511,
    y: 60.921,
    width: 164.686,
    height: 219.057,
    transform: "rotate(-42.952 352.511 60.921)",
    stroke: "#3913D2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 351.805,
    y: 64.7034,
    width: 165.686,
    height: 220.057,
    transform: "rotate(-42.952 351.805 64.7034)",
    fill: "#00F58F"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 405.84,
    y: 77.5848,
    width: 164.686,
    height: 219.057,
    transform: "rotate(-42.952 405.84 77.5848)",
    stroke: "#3913D2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 405.134,
    y: 81.3674,
    width: 165.686,
    height: 220.057,
    transform: "rotate(-42.952 405.134 81.3674)",
    fill: "#4E5D78"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 22.7067,
    y: 123.585,
    width: 164.686,
    height: 219.057,
    transform: "rotate(-42.952 22.7067 123.585)",
    stroke: "#3913D2"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 127.367,
    width: 165.686,
    height: 220.057,
    transform: "rotate(-42.952 22 127.367)",
    fill: "url(#paint0_linear_1712_3081)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 76.0319,
    y: 140.249,
    width: 164.686,
    height: 219.057,
    transform: "rotate(-42.952 76.0319 140.249)",
    stroke: "#3913D2"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 75.3252,
    y: 144.032,
    width: 165.686,
    height: 220.057,
    transform: "rotate(-42.952 75.3252 144.032)",
    fill: "url(#paint1_linear_1712_3081)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 318.707,
    y: 113.294,
    width: 164.686,
    height: 219.057,
    transform: "rotate(-42.952 318.707 113.294)",
    fill: "white",
    stroke: "#FFAB00"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 318,
    y: 136.598,
    width: 165.686,
    height: 220.057,
    transform: "rotate(-42.952 318 136.598)",
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 372.032,
    y: 129.956,
    width: 164.686,
    height: 219.057,
    transform: "rotate(-42.952 372.032 129.956)",
    fill: "white",
    stroke: "#FFAB00"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 371.325,
    y: 133.739,
    width: 165.686,
    height: 220.057,
    transform: "rotate(-42.952 371.325 133.739)",
    fill: "white"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: -12.9131,
    y: 13.443,
    width: 138.982,
    height: 85.5236,
    transform: "rotate(-43.4156 -12.9131 13.443)",
    fill: "#3913D2"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: -16,
    y: 12.7206,
    width: 138.982,
    height: 85.5236,
    transform: "rotate(-43.4156 -16 12.7206)",
    fill: "url(#paint2_linear_1712_3081)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1712_3081",
    x1: 22,
    y1: 127.367,
    x2: 206.203,
    y2: 143.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3913D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC5CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1712_3081",
    x1: 75.3252,
    y1: 144.032,
    x2: 259.528,
    y2: 160.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3913D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC5CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1712_3081",
    x1: -16,
    y1: 15.5094,
    x2: 132.466,
    y2: 39.4615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCFFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75CFFA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmShapes1);
export default __webpack_public_path__ + "static/media/crmShapes1.f4e92354.svg";
export { ForwardRef as ReactComponent };